import useMediaQuery from 'Hooks/useMediaQuery';

type Props = React.PropsWithChildren<{
  query: string;
  defaultMatch?: boolean;
}>;

const QueryComponent = (props: Props) => {
  const { children, query, defaultMatch } = props;
  const matches = useMediaQuery(query, defaultMatch);
  if (!matches) {
    return null;
  }

  return <>{children}</>;
};

export default QueryComponent;
